/**
 * Checking In For Someone Else Guard
 *
 * Guards that check if the patient is checking in on behalf of another person.
 */

import type { GuardWithMetadata } from "./sms.guard";

/**
 * Is Checking In For Someone Else Guard
 *
 * Checks if the patient answered "Yes" to the proxy check-in question.
 * This determines whether the proxy (minor check) path is shown.
 *
 * NOTE: Guards run BEFORE actions, so we check event.data (not context)
 */
export const isCheckingInForSomeoneElse: GuardWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState guard params are complex
  impl: ({ context, event }: { context: any; event: any }) => {
    if (
      event.data &&
      typeof event.data.checkingInForSomeoneElse === "boolean"
    ) {
      return event.data.checkingInForSomeoneElse === true;
    }

    // Fallback to context (for state restoration)
    return context.checkingInForSomeoneElse === true;
  },
  metadata: {
    displayName: "isCheckingInForSomeoneElse",
    description: "Patient answered YES to proxy check-in question",
    requiresContext: ["checkingInForSomeoneElse"],
    category: "context",
  },
};
